/**
 * Payment transaction status enum matching PaymentTransactionStatus.java
 * @see pbt-service-finance/client/src/main/java/vet/petabyte/finance/client/dto/PaymentTransactionStatus.java
 */
export enum PaymentTransactionStatus {
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  COMPLETED = 'COMPLETED',
  SETTLED = 'SETTLED',
  PROCESSING = 'PROCESSING',
  VOIDED = 'VOIDED',
  VOID_PENDING = 'VOID_PENDING',
}

/**
 * Transaction type names from GraphQL subscription responses.
 * Used to identify the type of transaction in subscription handlers.
 */
export enum PaymentTransactionTypeName {
  COMPLETED_SALE_TRANSACTION = 'CompletedSaleTransaction',
  COMPLETED_REFUND_TRANSACTION = 'CompletedRefundTransaction',
  FAILED_REFUND_TRANSACTION = 'FailedRefundTransaction',
  PENDING_REFUND_TRANSACTION = 'PendingRefundTransaction',
  PENDING_SALE_TRANSACTION = 'PendingSaleTransaction',
}

/**
 * Status name that indicates a failed void attempt.
 * TODO(CPAY-325): Confirm this value with BE once finalized
 */
export const VOID_FAILED_STATUS = 'VOID_FAILED'
